/**
 * Plausible page analytics for the marketing site.
 *
 * Gated on `VITE_PLAUSIBLE_DOMAIN`, which CI sets ONLY on the `main`
 * deploy (.github/workflows/deploy-marketing.yml). Local builds and the
 * dev deploy leave it unset, so nothing is injected. No SDK dependency:
 * one deferred <script> tag. It auto-tracks pageviews, including
 * client-side route changes via history.pushState.
 */
const SCRIPT_SRC = 'https://plausible.io/js/script.js';

export function initAnalytics(
  domain: string | undefined = import.meta.env.VITE_PLAUSIBLE_DOMAIN,
): void {
  if (!domain || typeof document === 'undefined') return;
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;

  const script = document.createElement('script');
  script.defer = true;
  script.dataset.domain = domain;
  script.src = SCRIPT_SRC;
  document.head.appendChild(script);
}
